import type { ApiSchemas } from "./generated/index";

export type ProblemCode =
  ApiSchemas["ProblemDetails"]["properties"]["code"]["enum"][number];

export interface ProblemDetails {
  readonly type: string;
  readonly title: string;
  readonly status: number;
  readonly detail: string;
  readonly instance: string;
  readonly code: ProblemCode;
  readonly correlationId: string;
  readonly currentVersion?: number;
  readonly currentStage?: string | null;
  readonly currentAssigneeId?: string | null;
}

export function isProblemDetails(value: unknown): value is ProblemDetails {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  const problem = value as Readonly<Record<string, unknown>>;
  return (
    typeof problem.type === "string" &&
    typeof problem.title === "string" &&
    typeof problem.status === "number" &&
    typeof problem.detail === "string" &&
    typeof problem.instance === "string" &&
    typeof problem.code === "string" &&
    typeof problem.correlationId === "string"
  );
}

export class ApiProblem extends Error {
  readonly status: number;
  readonly problem: ProblemDetails | undefined;

  constructor(status: number, problem?: ProblemDetails) {
    super(problem?.title ?? `Request failed with status ${status}`);
    this.name = "ApiProblem";
    this.status = status;
    this.problem = problem;
  }
}
